import { Tooltip } from "@material-ui/core";
import Chip, { ChipProps } from "@material-ui/core/Chip";
import React from "react";
import styled from "styled-components";

import { color } from "style/constants";

const greenStyle = `
&& {
  background: ${color.LIGHTGREEN};
  color: ${color.DARKGREEN};
}
`;

const purpleStyle = `
&& {
  background: ${color.LIGHTPURPLE};
  color:  ${color.DARKPURPLE};
}
`;

const blueStyle = `
&& {
  background: ${color.LIGHTBLUE};
  color: ${color.DARKBLUE};
}
`;

const redStyle = `
&& {
  background: ${color.LIGHTRED};
  color: ${color.DARKRED};
`;

const grayStyle = `
&& {
  background: ${color.LIGHTERGRAY};
  color: ${color.DARKGRAY};
}
`;

const orangeStyle = `
&& {
  background: ${color.LIGHTORANGE};
  color: ${color.ORANGE}
}`;

const brownStyle = `
&& {
  background: ${color.LIGHTBROWN};
  color: ${color.BROWN}
}`;

const ellipsisStyle = `
&& {
  span {
    display: inline-block;
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const StyledChip = styled(({ ...otherProps }) => <Chip {...otherProps} />)`
  && {
    ${props => props.label === "assessments in progress" && greenStyle}
    ${props => props.label === "completed" && greenStyle}
    ${props => props.label === "ready to score" && purpleStyle}
    ${props => props.label === "ready for review" && redStyle}
    ${props => props.label === "score finalized" && blueStyle}
    ${props => props.label === "scheduled" && blueStyle}
    ${props => props.label === "coaching sessions completed" && redStyle}
    ${props => props.label.includes("cancel") && redStyle}
    ${props => props.label === "Coaching" && grayStyle}
    ${props => props.label === "Assessment" && blueStyle}
    ${props => props.label === "Training" && orangeStyle}
    ${props => props.label === "Habit" && redStyle}
    ${props => props.label === "Resources" && brownStyle}
    ${props => props.label === "BrainHQ Assessment" && greenStyle}
    ${props => props.label === "BrainHQ Training" && greenStyle}
    ${props => props.label === "Smart" && purpleStyle}
    ${props => props.ellipsis && ellipsisStyle}
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    border-radius: 4px;
  }
`;

interface Props {
  value: string;
  substatus?: string;
  ellipsis?: boolean;
}

type StatusChipProps = Props & ChipProps;

export default function StatusChip({
  value,
  substatus,
  ellipsis,
  ...props
}: StatusChipProps): JSX.Element {
  const label = value ? `${value}${substatus ? ` [${substatus}]` : ""}`.replace(/_/g, " ") : "N/A";
  const tooltip = label
    .split(" ")
    .map(x => x.charAt(0).toUpperCase() + x.substring(1))
    .join(" ");

  return (
    <Tooltip title={tooltip}>
      <div>
        <StyledChip {...props} label={label} ellipsis={ellipsis?.toString()} />
      </div>
    </Tooltip>
  );
}
